<template>
	<div class="col-12">
		<table class="table table-bordered bg-white table-sm">
			<tbody>
				<tr>
					<td>
						ID: <b>{{ medida.id }}</b> 
						<br/>
						Protocolo: <b>{{ medida.protocolo }}</b>
					</td>
					<td>
						Data Cadastro: <b>{{ medida.cadastrado }}</b>
					</td>
				</tr>
				<tr>
					<td colspan="2">
						Técnico autor:
						<b>{{ medida.autor }}</b>
					</td>
				</tr>
				<tr>
					<td>
						Técnico: <b v-if="medida.responsavel">{{ medida.responsavel.name }}</b> - <span> {{ medida.responsavel.profissao ?? 'Não informado' }} </span>
					</td> 
					<td>
						Atualizado: <b>{{ medida.atualizado }}</b>
					</td>
				</tr>
				<tr>
					<td>
						Unidade: <b v-if="medida.unidade">{{ medida.unidade.nome }}</b>
					</td>
					<td>Status: <b v-html="medida.status_nome"></b></td>
				</tr>
				<tr>
					<td>
						Nome Adolescente:
						<b v-if="!medida.usuario_nome_social" >{{ medida.usuario_nome }} </b>
						<b v-else>
							{{ medida.usuario_nome_social }} ( N.R.: )
							<span v-if="nome">
								{{ medida.usuario_nome }}
								<a href="#" @click.prevent="nome = false" ><i class="fas fa-eye-slash"></i></a>
							</span>
							<span v-else><a href="#" @click.prevent="nome = true" ><i class="fas fa-eye"></i></a></span>
						</b>
					</td>
					<td>
						Idade:
						<b>{{ medida.usuario_idade }} Anos </b>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
export default {
	data() {
		return {
			nome: false
		};
	},
	props: ["medida"],
	watch: {
		name: function (value) {
      		value ? true : false;
    	},
  	},
};
</script>
